@if (fieldSet.includes(ServiceDataFields.PregnancyType)) {
  <div class="row">
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label for="pregnancyType">{{
            'serviceData.form.pregnancyType' | translate
          }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <app-select
            class="w-100"
            id="pregnancyType"
            appInputValidationStatus
            formControlName="pregnancyType"
            [attr.data-cy]="ServiceDataFields.PregnancyType + '-select'"
            [placeholder]="
              'serviceData.form.placeholders.pregnancyType' | translate
            "
          >
            @for (type of Object.keys(PregnancyType); track type) {
              <app-select-option
                [value]="PregnancyType[type]"
                [label]="PregnancyType[type]"
              />
            }
          </app-select>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="pregnancyType"
            translations="validation.generic"
            [attr.data-cy]="
              ServiceDataFields.PregnancyType + '-validation-error'
            "
          ></app-validation-error>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 mb-3">
      @if (form.get('pregnancyType').value === PregnancyType.twins) {
        <div class="row align-items-center">
          <div class="col-12 col-sm-4 mb-1">
            <label for="chorionicityType">{{
              'serviceData.form.chorionicityType' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-8">
            <app-select
              class="w-100"
              appInputValidationStatus
              formControlName="chorionicityType"
              id="chorionicityType"
              data-cy="ChorionicityType-select"
              [placeholder]="
                'serviceData.form.placeholders.chorionicityType' | translate
              "
            >
              @for (type of Object.keys(ChorinicityType); track type) {
                <app-select-option
                  [value]="type"
                  [label]="ChorinicityType[type]"
                />
              }
            </app-select>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-sm-8">
            <app-validation-error
              for="chorionicityType"
              translations="validation.generic"
              data-cy="ChorionicityType-validation-error"
            ></app-validation-error>
          </div>
        </div>
      }
    </div>
  </div>
}
